module.exports = __webpack_public_path__ + "img/des_distanceday_1.8e784864.jpg";